import React from 'react';
import {
  Filter as FilterAdmin,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';

import { PeriodoInput } from '../../Components/InputsReactAdmin';
import { STATUS_ATIVO } from '../../utils';
import { choicesOrigem, choicesTipo } from './choices';

const Filter = (props) => (
  <FilterAdmin {...props}>
    {/* <IntegerInput source="produto_id" label="Produto_Id" /> */}
    <SelectInput
      source="tipo"
      choices={choicesTipo}
      label="Tipo"
      allowEmpty={false}
    />
    <SelectInput
      source="origem"
      choices={choicesOrigem}
      label="Origem"
      allowEmpty={false}
    />
    <PeriodoInput
      source="periodo"
      label="Período"
      defaultValue={{
        start: new Date(),
        end: new Date(),
      }}
    />
    <ReferenceInput
      fullWidth
      label="Produto"
      source="produto_id"
      reference="produtos_search_filter"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      perPage={10}
      allowEmpty={false}
      filter={{ status: STATUS_ATIVO }}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
  </FilterAdmin>
);

export default Filter;
